export const SERVER = process.env.REACT_APP_SERVER_ENDPOINT;
export const REACT_APP_ENVIRONMENT_MODE = process.env.REACT_APP_ENVIRONMENT_MODE;
export const SERVER_DOMAIN = process.env.REACT_APP_SERVER_ENDPOINT;

export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  USERS_ADMIN: "USERS_ADMIN",
  MARKETING_ADMIN: "MARKETING_ADMIN",
};
